import cardStyles from 'common/settings-layout/settings-card.module.scss';
import { QrCodeCard } from 'common/qr-code-card';
import { classnames } from 'helpers/utils';
import styles from './qr-code-section.module.scss';

type QrCodeSectionProps = {
  vault: VaultType;
};

// The printed QR codes that open this whole vault (linked in the CMS). The
// vault's payload also lists codes for its albums and memories; those show
// on the album and the memory instead.
const QrCodeSection = ({ vault }: QrCodeSectionProps) => {
  const vaultQrCodes = (vault.qrCodes ?? []).filter(
    (qrCode) => !qrCode.clipId && !qrCode.albumId && !qrCode.contentId,
  );
  if (vaultQrCodes.length === 0) return null;

  return (
    <div className={classnames(cardStyles.card, styles.qrCodeSection)}>
      <p className="text__title2__gray800">QR code</p>
      <p className={styles.description}>
        Scanning it opens this vault&apos;s memories. Private memories
        aren&apos;t shown.
      </p>
      {vaultQrCodes.map((qrCode) => (
        <QrCodeCard key={qrCode.id} qrCode={qrCode} large />
      ))}
    </div>
  );
};

export { QrCodeSection };
